module.exports = __webpack_public_path__ + "static/media/instagram.e4d266c3.svg";